"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zendesk = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var AuthActions = require("@caddigital/sok-reducers/lib/actions/auth/zendesk");
var Types = require("types");
var mapStateToProps = function (state) {
    return {
        zToken: state.auth.zendesk.token
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    zendeskToken: function () { return dispatch(AuthActions.createZendeskTokenRequest()); },
    clearToken: function () { return dispatch(AuthActions.resetZendeskToken()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var zendesk = null;
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (zendesk && this.props.zToken !== '') {
            var url = "https://sokopro.zendesk.com/access/jwt?jwt=".concat(this.props.zToken, "&return_to=https://sokopro.zendesk.com/");
            zendesk.location.href = url;
            zendesk.focus();
            zendesk = null;
            this.props.clearToken();
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.zToken !== nextProps.zToken) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.Zendesk = enhance(function (props) { return (React.createElement(sok_ui_1.Button, { color: 'dark-gray', size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-book' }), onClick: function () {
        zendesk = window.open('about:blank', 'blank');
        props.zendeskToken();
    } }, (0, translation_1.getLocalization)('global/tutorials'))); });
